import { keepTrackApi } from '@app/keepTrackApi';
import { Line, LineColors } from './line';
export class SensorToSunLine extends Line {
    sensor_;
    constructor(sensor) {
        super();
        this.sensor_ = sensor;
        this.color_ = LineColors.ORANGE;
    }
    update() {
        const eci = this.sensor_.eci(keepTrackApi.getTimeManager().simulationTimeObj);
        const eciArr = [eci.x, eci.y, eci.z];
        this.updateVertBuf([eciArr, keepTrackApi.getScene().sun.position]);
    }
}
